export default {"src":"/_next/static/media/game.d7d22e18.svg","height":40,"width":55,"blurWidth":0,"blurHeight":0};